module.exports = __webpack_public_path__ + "img/ic24refresh.fa760777.svg";